"use client";

import React from "react";
import { TrendingUp, Globe, ShieldCheck, ShoppingBag, Handshake, Settings } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export default function APortfolioOfOwnedOperations() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const ventures = [{
    icon: TrendingUp,
    title: "Vostoka",
    description: "Owned Tactical Division for Eastern European Logistics & Distribution Network.",
    result: "Result: 40% efficiency increase in cross-border flow."
  }, {
    icon: Globe,
    title: "Seo Russia",
    description: "Owned Tactical Division for Russian/CSI Digital Infrastructure & Search Dominance.",
    result: "Result: #1 Market Position in localized search rankings."
  }, {
    icon: ShieldCheck,
    title: "Digital Tactic",
    description: "Owned tactical hub for custom international web solutions and architecture.",
    result: "Result: 100% Security Uptime for global enterprise assets."
  }, {
    icon: ShoppingBag,
    title: "Export Hub",
    description: "Dedicated channel for high-volume consumer goods distribution and retail scaling.",
    result: "Result: Seamless Global Retail Presence across 12+ regions."
  }, {
    icon: Handshake,
    title: "Venture Partners",
    description: "Strategic investment arm focused on emerging market tech and infrastructure.",
    result: "Result: Multi-million Euro Portfolio under active management."
  }, {
    icon: Settings,
    title: "Core Ops",
    description: "Back-end management and architectural control for the global holding network.",
    result: "Result: Infinite Scalability for new market entries."
  }];
  return <section id="a-portfolio-of-owned-operations" className="py-24 bg-background relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
            A Portfolio of Owned Operations
          </h2>
          <p className="font-sans text-lg md:text-xl font-medium text-muted-foreground">
            Strategically integrated digital assets under Geroi.eu management.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 lg:grid-cols-3 gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {ventures.map((venture, i) => <Card key={i} data-index={i} className="relative overflow-hidden bg-card backdrop-blur-md border-border/60 shadow-sm hover:shadow-md hover:border-primary/30 transition-all duration-500 group min-h-[300px] flex flex-col justify-end">
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent pointer-events-none" />
              
              <CardHeader className="relative z-10 pb-2">
                <div className="relative inline-flex items-center justify-center w-12 h-12 text-primary mb-4 transform transition-transform duration-500 group-hover:scale-110 group-hover:text-accent-foreground">
                  <venture.icon className="w-full h-full stroke-[1.5]" />
                </div>
                <CardTitle className="font-serif text-2xl text-foreground">{venture.title}</CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <CardDescription className="font-sans text-base text-muted-foreground/90">
                  {venture.description}
                  <span className="block mt-3 font-bold text-primary tracking-wide">
                    {venture.result}
                  </span>
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}